import { TrendExaminationYear } from "./trend-year";
export default TrendExaminationYear;
